import { combineReducers } from '@reduxjs/toolkit';
import FormReducers from './form';

const identityProviderReducers = combineReducers({
  form: FormReducers
});

export default identityProviderReducers;
